// @ts-nocheck
import axios from 'axios';
import { create } from 'zustand';
import { API_URL } from '../configs';
import { validateUrl } from '../helper';
import { toastTypes } from '../enums';
import getRoot from './root';

const HOOK_TEMPLATE = {
  dataToSend: {
    capture: {
      created_ts: false,
      email: false,
      email_count: false,
      form_data: false,
      url: false,
    },
  },
  disabled: false,
  name: '',
  url: '',
};

const useClientHooksStore = create((set, get) => ({
  hooks: {},
  hookObjTemplate: HOOK_TEMPLATE,

  reset: () => set({ hooks: {} }),

  getAllHooks: async () => {
    const root = getRoot();
    try {
      const res = await axios.get(`${API_URL}/api/clientHooks`);
      if (res.data.success) {
        set({ hooks: res.data.hooks || {} });
      } else {
        root.failure('Failed to retrieve webhooks.');
      }
    } catch (e) {
      root.failure('Failed to retrieve webhooks.');
    }
  },

  deleteHook: async (hookId) => {
    const root = getRoot();
    try {
      const res = await axios.delete(`${API_URL}/api/clientHooks/${hookId}`);
      if (res.data.success) {
        root.success('Webhook deleted successfully!', toastTypes.deleteHook);
        root.clearToast(toastTypes.deleteHook);
      } else {
        root.failure('Failed to delete webhook.', toastTypes.deleteHook);
      }
    } catch (e) {
      root.failure('Failed to delete webhook.', toastTypes.deleteHook);
    } finally {
      get().getAllHooks();
    }
  },

  addHook: async (hook) => {
    const root = getRoot();
    try {
      const sanitizedHook = { ...hook };
      sanitizedHook.name = sanitizedHook.name.trim();
      sanitizedHook.url = validateUrl(sanitizedHook.url);
      const res = await axios.post(`${API_URL}/api/clientHooks/`, { hook: sanitizedHook });
      if (res.data.success) {
        root.success('Webhook added successfully!', toastTypes.addHook);
        root.clearToast(toastTypes.addHook);
      } else {
        root.failure('Failed to add a webhook.', toastTypes.addHook);
      }
    } catch (e) {
      root.failure('Failed to add a webhook.', toastTypes.addHook);
    } finally {
      get().getAllHooks();
    }
  },

  updateHook: async (hookId, hook) => {
    const root = getRoot();
    try {
      const sanitizedHook = { ...hook };
      sanitizedHook.name = sanitizedHook.name.trim();
      sanitizedHook.url = validateUrl(sanitizedHook.url);
      const res = await axios.patch(`${API_URL}/api/clientHooks/${hookId}`, { updatedHook: sanitizedHook });
      if (res.data.success) {
        root.success('Webhook updated successfully!', toastTypes.updateHook);
        root.clearToast(toastTypes.updateHook);
      } else {
        root.failure('Failed to update webhook.', toastTypes.updateHook);
      }
    } catch (e) {
      root.failure('Failed to update webhook.', toastTypes.updateHook);
    } finally {
      get().getAllHooks();
    }
  },
}));

export default useClientHooksStore;
